module.exports = __webpack_public_path__ + "static/media/icon-widget-close.678ce14a.svg";